import React, { useState, useEffect } from 'react'


export default function StopMarker({ stop, trackColor, tipBelow, onClick }) {
  const [hov, setHov] = useState(false)
  const isNP = String(stop.type) === '2' || String(stop.type) === '3'
  const isTP = stop.is_timing_point && String(stop.type) === '1'

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5, cursor: 'pointer' }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onClick}
      >
      {isTP ? (
        <div style={{
          width: 13, height: 13, background: trackColor,
          border: '2.5px solid var(--bg-surface)', borderRadius: 3,
          transform: hov ? 'rotate(45deg) scale(1.3)' : 'rotate(45deg)',
          boxShadow: `0 0 0 2px ${trackColor}`,
          transition: 'transform 0.15s ease', flexShrink: 0,
        }} />
      ) : isNP ? (
        <div style={{
          width: 9, height: 9, background: 'var(--bg-muted)',
          border: '2px solid var(--border)', borderRadius: '50%',
          transform: hov ? 'scale(1.3)' : 'scale(1)',
          transition: 'transform 0.15s', flexShrink: 0,
        }} />
      ) : (
        <div style={{
          width: 10, height: 10, background: 'var(--bg-surface)',
          border: `2.5px solid ${trackColor}`, borderRadius: '50%',
          transform: hov ? 'scale(1.4)' : 'scale(1)',
          transition: 'transform 0.15s', flexShrink: 0,
        }} />
      )}

      {hov && (
        <div className="stop-tooltip" style={{
          position: 'absolute', pointerEvents: 'none', zIndex: 200,
          background: 'var(--bg-surface)', border: '1px solid var(--border)',
          borderRadius: 8, padding: 8, width: 168, boxShadow: 'var(--shadow-lg)',
          [tipBelow ? 'top' : 'bottom']: 'calc(100% + 10px)',
          left: '50%', transform: 'translateX(-50%)',
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, fontFamily: "'JetBrains Mono'", marginBottom: 2 }}>{stop.id}</div>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>{stop.name}</div>
          <div style={{ fontSize: 10, color: 'var(--text-muted)', fontFamily: "'JetBrains Mono'" }}>{stop.code}</div>
          {isTP && <div style={{ marginTop: 6, display: 'inline-flex', alignItems: 'center', gap: 4, background: 'var(--timing-point)', color: 'var(--text-on-accent)', fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 3, letterSpacing: '0.05em' }}>◆ TIMING POINT</div>}
          {isNP && <div style={{ marginTop: 6, display: 'inline-flex', alignItems: 'center', gap: 4, background: 'var(--bg-muted)', color: 'var(--text-muted)', fontSize: 9, fontWeight: 600, padding: '2px 6px', borderRadius: 3, border: '1px solid var(--border)' }}>GARAGE RUN</div>}
        </div>
      )}
    </div>
  )
}
